import React from 'react';
import { Link } from 'react-router-dom';

const VIDEO_SRC = '404.mp4';

export default function NotFoundPage() {
  return (
    <div style={{
      minHeight: '100vh',
      background: '#000',
      color: '#fff',
      fontFamily: "'Inter', system-ui, sans-serif",
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: 32, textAlign: 'center',
    }}>
      <div style={{ maxWidth: 720, width: '100%' }}>
        <p style={{ fontFamily: 'Inter, sans-serif', fontSize: 11, fontWeight: 700, letterSpacing: '0.24em', color: '#9D1515', margin: '0 0 18px', textTransform: 'uppercase' }}>
          Out of Bounds
        </p>
        <video
          autoPlay muted loop playsInline
          src={`/${VIDEO_SRC}`}
          style={{
            display: 'block',
            width: '100%',
            maxWidth: 600,
            margin: '0 auto',
            background: '#000',
          }}
        />
        <h2 style={{
          fontFamily: "'Bebas Neue','Oswald',sans-serif",
          fontSize: 'clamp(28px, 5vw, 44px)',
          color: '#fff', margin: '12px 0 18px', letterSpacing: '0.06em',
        }}>
          THIS PLAY ISN'T IN THE BOOK
        </h2>
        <p style={{ fontSize: 14, lineHeight: 1.7, color: 'rgba(255,255,255,0.55)', margin: '0 0 32px' }}>
          The page you're looking for doesn't exist or has been moved. Head back to the homepage and pick a new route.
        </p>
        <Link to="/" style={{
          display: 'inline-block',
          background: '#9D1515', color: '#fff', textDecoration: 'none',
          fontFamily: "'Bebas Neue','Oswald',sans-serif",
          fontSize: 14, letterSpacing: '0.18em',
          padding: '14px 28px',
          transition: 'background 0.15s',
        }}>
          ← BACK TO OVR LEAGUE
        </Link>
        <div style={{ marginTop: 36, fontSize: 12, color: 'rgba(255,255,255,0.3)' }}>
          Need help? Email{' '}
          <a href="mailto:ovrleague@gmail.com" style={{ color: '#9D1515', textDecoration: 'none' }}>
            ovrleague@gmail.com
          </a>
        </div>
      </div>
    </div>
  );
}
